{
  "selection": {
    "title": "NEXL AI",
    "description": "Select content that you want to generate",
    "aria_label": "nexl ai"
  },
  "event_pack": {
    "title": "Event Pack",
    "description": "Use this to generate event invitation for your email, linkedIn post and your website",
    "header": "Nexl AI - Event Pack",
    "instructions": "Please fill in the necessary fields for personalized message. Click 'generate' to see your result.",
    "form": {
      "start_time_label": "Start Time",
      "start_time_placeholder": "When is the event?",
      "location_label": "Location",
      "location_placeholder": "Where is the location of the event? ",
      "description_label": "What is the event about?",
      "description_placeholder": "Describe your event in a few sentences. What is the purpose, and what are some key features?",
      "validation": {
        "start_time_required": "Please enter a start time",
        "location_required": "Please enter a location",
        "description_required": "Please enter a description"
      }
    },
    "tabs": {
      "email": "Email",
      "linkedin_post": "LinkedIn Post",
      "website": "Website"
    }
  },
  "marketing_email": {
    "title": "Marketing Email",
    "description": "Use this to generate content for your marketing email",
    "header": "Nexl AI - Marketing Email",
    "instructions": "Please fill in the necessary fields for personalized email message. Click 'generate' to see your result.",
    "form": {
      "description_label": "What information do you plan to include?",
      "description_placeholder": "Tell us a little bit about the content you plan to include.",
      "validation": {
        "description_required": "Please enter a description"
      }
    }
  },
  "linkedin_post": {
    "title": "LinkedIn Post",
    "description": "Use this to generate content for your LinkedIn Post",
    "header": "Nexl AI - LinkedIn",
    "instructions": "Please fill in the necessary fields for personalized LinkedIn content. Click 'generate' to see your result."
  },
  "response": {
    "waiting_message": "Waiting for ChatGPT response",
    "try_again_message": "Please try again later",
    "no_content_title": "No Content Generated",
    "no_content_description": "Fill in the fields, and click 'Generate' when you are ready",
    "no_response_title": "No Response Received"
  },
  "actions": {
    "start": "Start",
    "generate": "Generate"
  }
}
